import img1 from './img/compound1.png';
import img2 from './img/compound2.png';

export const dummyTitle = ['Image', 'Name', 'Keywords', 'Science Index'];


export const dummyData_article = [
	{
		Paper_id: '54305',
		Title:
			'The effects of pool size and beaver activity on distribution and abundance of warm-water fishes in a north Missouri stream',
		Summary:
			'The linear distribution of fishes appeared to be related to stream gradient and area of the watershed; headwater species occurred where the gradient was 8.2 feet per mile, and the watershed area was less than 93 square miles. The influence of large deep pools on species distribution is possibly more significant than, and superimposed on, this basic pattern. The presence of beaver pools in the headwater section affected fish habitat through (1) a greatly increased volume of water;(2) providing deep pools in times of intermittent ',
		Authors: 'WD Hanson and RS Campbell',
		Journal_title: 'American Midland Naturalist',
		Year: '1963',
		Cited_by: '63',
		Link_url: 'http://www.jstor.org/stable/2422849',
		no: 0,
	},
	{
		Paper_id: '54288',
		Title: 'Present distribution of a rare Tennessee fish',
		Summary: 'Unknown',
		Authors: 'LM Madison',
		Journal_title: 'Journal of the Tennessee Academy of Science',
		Year: '1995',
		Cited_by: '6',
		Link_url: 'Unknown',
		no: 1,
	},
	{
		Paper_id: '54289',
		Title:
			'Physical Data and Biological Data for Algae, Aquatic Invertebrates, and Fish from Selected Reaches on the Carson and Truckee Rivers, Nevada and California, 1993',
		Summary:
			'MATERIALS AND METHODS,-Sampling of the ponds were conducted from May 1968 through August 1969 with collections taken at monthly and bimonthly intervals. No samples were obtained during the period when ice covered the ponds. Most of the material was preserved in either 5% formalin with buffer or Transeau’s Solution (6 parts water: 3 parts 95% ethyl alcohol: 1 part formalin). Some samples were brought back to the laboratory, …',
		Authors: 'DR Markey and RH Hevly',
		Journal_title: 'Journal of the Arizona Academy of Science',
		Year: '1973',
		Cited_by: '3',
		Link_url: 'Unknown',
		no: 1,
	},
];
export const dummyData_Behavior = {
	Actual_Evapotranspiration_Rate_in_Geographic_Range: '465.52 millimeters per month (mean)',
	Age_at_Eye_Opening: '0.5 days (average)',
	Diet_Breadth: 3,
	Dispersal_Age: '729.99 days (average)',
	Extinction_Status: 'extant',
	'Geographic_Range (size of area)': '15377760.47 km^2',
	Habitat_Breadth: 3,
	Human_Population_Density: '0 individuals per square kilometer (min)',
	Human_Population_Density_Change: '0.05 (mean)',
	'Inter-birth Interval': '365 days',
	Litters_per_Year: '1 (average)',
	Mating_System: 'monogamous',
	Potential_Evapotranspiration_Rate_in_Geographic_Range: '632.25 millimeters per month (mean)',
	Precipitation_in_Geographic_Range: '52.36 millimeters per month (mean)',
	Prenatal_Development_Duration: '128 days',
	Locomotion: 'swimming',
	Body_Mass: '415.17 g (newborn animal, average)',
};

export const dummyData_Compounds = [
	{
		Image: img1,
		Name: 'Nitrobacter ferritin',
		Synonyms: 'Nitrobacter ferritin',
		Molecular_Weight: '1149.4 ',
		Molecular_Formula: 'C52H84N12O15S',
		Topological_Polar_Surface_Area: 468,
		Complexity: 2080,
		'XLogP3-AA': '-5.8',
		Heavy_Atom_Count: 80,
		Hydrogen_Bond_Donor_Count: 14,
		Hydrogen_Bond_Acceptor_Count: 19,
		Rotatable_Bond_Count: 38,
		InChI:
			'InChI=1S/C52H84N12O15S/c1-6-30(4)44(51(78)61-37(25-41(68)69)48(75)57-32(28-65)24-31-15-17-33(66)18-16-31)63-50(77)43(29(2)3)62-47(74)36(13-8-10-21-54)60-49(76)39-14-11-22-64(39)52(79)38(26-42(70)71)58-40(67)27-56-46(73)35(12-7-9-20-53)59-45(72)34(55)19-23-80-5/h15-18,28-30,32,34-39,43-44,66H,6-14,19-27,53-55H2,1-5H3,(H,56,73)(H,57,75)(H,58,67)(H,59,72)(H,60,76)(H,61,78)(H,62,74)(H,63,77)(H,68,69)(H,70,71)',
		Canonical_SMILES:
			'CCC(C)C(C(=O)NC(CC(=O)O)C(=O)NC(CC1=CC=C(C=C1)O)C=O)NC(=O)C(C(C)C)NC(=O)C(CCCCN)NC(=O)C2CCCN2C(=O)C(CC(=O)O)NC(=O)CNC(=O)C(CCCCN)NC(=O)C(CCSC)N',
		InChI_Key: 'OADJURFAGVHFQN-UHFFFAOYSA-N',
		IUPAC_Name:
			'3-[[2-[[2-[[6-amino-2-[[1-[2-[[2-[[6-amino-2-[(2-amino-4-methylsulfanylbutanoyl)amino]hexanoyl]amino]acetyl]amino]-3-carboxypropanoyl]pyrrolidine-2-carbonyl]amino]hexanoyl]amino]-3-methylbutanoyl]amino]-3-methylpentanoyl]amino]-4-[[1-(4-hydroxyphenyl)-3-oxopropan-2-yl]amino]-4-oxobutanoic acid',
		Available_Date: 20191104,
		Source: 'The Natural Products Atlas',
		Industial_Category: 'Curation Efforts',
	},
	{
		Image: img2,
		Name: 'Reltecimod sodium',
		Synonyms: 'Reltecimod sodium;1943755-99-4 (sodium);AB103 sodium;Reltecimod sodium [USAN];UNII-4F6G4PH43M',
		Molecular_Weight: '1059.2 g/mol',
		Molecular_Formula: 'C46H71N10NaO15S',
		Topological_Polar_Surface_Area: 422,
		Complexity: 1930,
		'XLogP3-AA': '-',
		Heavy_Atom_Count: 73,
		Hydrogen_Bond_Donor_Count: 12,
		Hydrogen_Bond_Acceptor_Count: 17,
		Rotatable_Bond_Count: 29,
		InChI:
			'InChI=1S/C46H72N10O15S.Na/c1-22(2)18-30(52-39(63)29(15-17-72-8)50-43(67)34-10-9-16-56(34)45(69)33(21-57)54-37(61)24(5)47)42(66)55-36(23(3)4)44(68)48-25(6)38(62)51-31(19-27-11-13-28(58)14-12-27)41(65)53-32(20-35(59)60)40(64)49-26(7)46(70)71;/h11-14,22-26,29-34,36,57-58H,9-10,15-21,47H2,1-8H3,(H,48,68)(H,49,64)(H,50,67)(H,51,62)(H,52,63)(H,53,65)(H,54,61)(H,55,66)(H,59,60)(H,70,71);/q;+1/p-1/t24-,25+,26-,29+,30+,31+,32+,33+,34+,36+;/m1./s1',
		Canonical_SMILES:
			'CC(C)CC(C(=O)NC(C(C)C)C(=O)NC(C)C(=O)NC(CC1=CC=C(C=C1)O)C(=O)NC(CC(=O[O-])C(=O)NC(C)C(=O)O)NC(=O)C(CCSC)NC(=O)C2CCCN2C(=O)C(CO)NC(=O)C(C)N.[Na+]',
		InChI_Key: '',
		IUPAC_Name:
			'D-alanyl-L-seryl-L-prolyl-L-methionyl-L-leucyl-L-valyl-L-alanyl-L-tyrosyl-L-alpha-aspartyl-D-alanine sodium salt',
		Available_Date: 20170521,
		Source: 'The Natural Products Atlas',
		Industial_Category: 'Curation Efforts',
	},
	{
		Image: img2,
		Name: 'hi im beaver lol',
		Synonyms: 'Reltecimod sodium;1943755-99-4 (sodium);AB103 sodium;Reltecimod sodium [USAN];UNII-4F6G4PH43M',
		Molecular_Weight: '1059.2 g/mol',
		Molecular_Formula: 'C46H71N10NaO15S',
		Topological_Polar_Surface_Area: 422,
		Complexity: 1930,
		'XLogP3-AA': '-',
		Heavy_Atom_Count: 73,
		Hydrogen_Bond_Donor_Count: 12,
		Hydrogen_Bond_Acceptor_Count: 17,
		Rotatable_Bond_Count: 29,
		InChI:
			'InChI=1S/C46H72N10O15S.Na/c1-22(2)18-30(52-39(63)29(15-17-72-8)50-43(67)34-10-9-16-56(34)45(69)33(21-57)54-37(61)24(5)47)42(66)55-36(23(3)4)44(68)48-25(6)38(62)51-31(19-27-11-13-28(58)14-12-27)41(65)53-32(20-35(59)60)40(64)49-26(7)46(70)71;/h11-14,22-26,29-34,36,57-58H,9-10,15-21,47H2,1-8H3,(H,48,68)(H,49,64)(H,50,67)(H,51,62)(H,52,63)(H,53,65)(H,54,61)(H,55,66)(H,59,60)(H,70,71);/q;+1/p-1/t24-,25+,26-,29+,30+,31+,32+,33+,34+,36+;/m1./s1',
		Canonical_SMILES:
			'CC(C)CC(C(=O)NC(C(C)C)C(=O)NC(C)C(=O)NC(CC1=CC=C(C=C1)O)C(=O)NC(CC(=O[O-])C(=O)NC(C)C(=O)O)NC(=O)C(CCSC)NC(=O)C2CCCN2C(=O)C(CO)NC(=O)C(C)N.[Na+]',
		InChI_Key: '',
		IUPAC_Name:
			'D-alanyl-L-seryl-L-prolyl-L-methionyl-L-leucyl-L-valyl-L-alanyl-L-tyrosyl-L-alpha-aspartyl-D-alanine sodium salt',
		Available_Date: 20170521,
		Source: 'The Natural Products Atlas',
		Industial_Category: 'Curation Efforts',
	},
];

export const dummyArticles = [
	{
		articles: [
			{
				title:
					'What is that',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
			{
				title:
					'A less harmful system of preparing robust fabrics for integrated self-cleaning, oil-water separation and water purification',
				journal_title: 'Environmental pollution (Barking, Essex : 1987)',
				authors: 'Maiping Yang, Chi Jiang, Weiqu Liu, Liyan Liang, Ke Pi',
				summary:
					'Although the development of constructing oil-water separation materials is quick, the defects of using harmful regents, weak stability and single function still exist. Here, we report an effective and less-harmful system with poly-dimethylsiloxane (PDMS)/ZnO composite solution to fabricate robust superhydrophobic surfaces for oil-water separation and removal of organic pollutant. The obtained samples were characterized by a range of instruments. The water contact angle (WCA) of coated cotton was 155.6°, whi',
				link_url: 'https://doi.org/10.1016/j.envpol.2019.113277',
				link_url_check: 'NONE',
				year: 2012,
				lang: 'en',
				keywords: ['water', 'robust', 'oil', 'regents weak', 'superhydrophobic'],
				Taxon_ids: [80489],
				science_index: 'Nanoparticles;Porosity;Textiles;Ultraviolet Rays;Water;Water Purification',
			},
		],
		taxa_id: 80489,
		cname: 'Here',
		sname: 'Here',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/7f/d4/f4/542.4071919458.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'What is that',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
			{
				title:
					'A less harmful system of preparing robust fabrics for integrated self-cleaning, oil-water separation and water purification',
				journal_title: 'Environmental pollution (Barking, Essex : 1987)',
				authors: 'Maiping Yang, Chi Jiang, Weiqu Liu, Liyan Liang, Ke Pi',
				summary:
					'Although the development of constructing oil-water separation materials is quick, the defects of using harmful regents, weak stability and single function still exist. Here, we report an effective and less-harmful system with poly-dimethylsiloxane (PDMS)/ZnO composite solution to fabricate robust superhydrophobic surfaces for oil-water separation and removal of organic pollutant. The obtained samples were characterized by a range of instruments. The water contact angle (WCA) of coated cotton was 155.6°, whi',
				link_url: 'https://doi.org/10.1016/j.envpol.2019.113277',
				link_url_check: 'NONE',
				year: 2012,
				lang: 'en',
				keywords: ['water', 'robust', 'oil', 'regents weak', 'superhydrophobic'],
				Taxon_ids: [80489],
				science_index: 'Nanoparticles;Porosity;Textiles;Ultraviolet Rays;Water;Water Purification',
			},
		],
		taxa_id: 80489,
		cname: 'Here',
		sname: 'Here',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/7f/d4/f4/542.4071919458.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'What is that',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
			{
				title:
					'A less harmful system of preparing robust fabrics for integrated self-cleaning, oil-water separation and water purification',
				journal_title: 'Environmental pollution (Barking, Essex : 1987)',
				authors: 'Maiping Yang, Chi Jiang, Weiqu Liu, Liyan Liang, Ke Pi',
				summary:
					'Although the development of constructing oil-water separation materials is quick, the defects of using harmful regents, weak stability and single function still exist. Here, we report an effective and less-harmful system with poly-dimethylsiloxane (PDMS)/ZnO composite solution to fabricate robust superhydrophobic surfaces for oil-water separation and removal of organic pollutant. The obtained samples were characterized by a range of instruments. The water contact angle (WCA) of coated cotton was 155.6°, whi',
				link_url: 'https://doi.org/10.1016/j.envpol.2019.113277',
				link_url_check: 'NONE',
				year: 2012,
				lang: 'en',
				keywords: ['water', 'robust', 'oil', 'regents weak', 'superhydrophobic'],
				Taxon_ids: [80489],
				science_index: 'Nanoparticles;Porosity;Textiles;Ultraviolet Rays;Water;Water Purification',
			},
		],
		taxa_id: 80489,
		cname: 'Here',
		sname: 'Here',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/7f/d4/f4/542.4071919458.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'What is that',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
			{
				title:
					'A less harmful system of preparing robust fabrics for integrated self-cleaning, oil-water separation and water purification',
				journal_title: 'Environmental pollution (Barking, Essex : 1987)',
				authors: 'Maiping Yang, Chi Jiang, Weiqu Liu, Liyan Liang, Ke Pi',
				summary:
					'Although the development of constructing oil-water separation materials is quick, the defects of using harmful regents, weak stability and single function still exist. Here, we report an effective and less-harmful system with poly-dimethylsiloxane (PDMS)/ZnO composite solution to fabricate robust superhydrophobic surfaces for oil-water separation and removal of organic pollutant. The obtained samples were characterized by a range of instruments. The water contact angle (WCA) of coated cotton was 155.6°, whi',
				link_url: 'https://doi.org/10.1016/j.envpol.2019.113277',
				link_url_check: 'NONE',
				year: 2012,
				lang: 'en',
				keywords: ['water', 'robust', 'oil', 'regents weak', 'superhydrophobic'],
				Taxon_ids: [80489],
				science_index: 'Nanoparticles;Porosity;Textiles;Ultraviolet Rays;Water;Water Purification',
			},
		],
		taxa_id: 80489,
		cname: 'Here',
		sname: 'Here',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/7f/d4/f4/542.4071919458.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'What is that',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
			{
				title:
					'A less harmful system of preparing robust fabrics for integrated self-cleaning, oil-water separation and water purification',
				journal_title: 'Environmental pollution (Barking, Essex : 1987)',
				authors: 'Maiping Yang, Chi Jiang, Weiqu Liu, Liyan Liang, Ke Pi',
				summary:
					'Although the development of constructing oil-water separation materials is quick, the defects of using harmful regents, weak stability and single function still exist. Here, we report an effective and less-harmful system with poly-dimethylsiloxane (PDMS)/ZnO composite solution to fabricate robust superhydrophobic surfaces for oil-water separation and removal of organic pollutant. The obtained samples were characterized by a range of instruments. The water contact angle (WCA) of coated cotton was 155.6°, whi',
				link_url: 'https://doi.org/10.1016/j.envpol.2019.113277',
				link_url_check: 'NONE',
				year: 2012,
				lang: 'en',
				keywords: ['water', 'robust', 'oil', 'regents weak', 'superhydrophobic'],
				Taxon_ids: [80489],
				science_index: 'Nanoparticles;Porosity;Textiles;Ultraviolet Rays;Water;Water Purification',
			},
		],
		taxa_id: 80489,
		cname: 'Here',
		sname: 'Here',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/7f/d4/f4/542.4071919458.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'What is that',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
			{
				title:
					'A less harmful system of preparing robust fabrics for integrated self-cleaning, oil-water separation and water purification',
				journal_title: 'Environmental pollution (Barking, Essex : 1987)',
				authors: 'Maiping Yang, Chi Jiang, Weiqu Liu, Liyan Liang, Ke Pi',
				summary:
					'Although the development of constructing oil-water separation materials is quick, the defects of using harmful regents, weak stability and single function still exist. Here, we report an effective and less-harmful system with poly-dimethylsiloxane (PDMS)/ZnO composite solution to fabricate robust superhydrophobic surfaces for oil-water separation and removal of organic pollutant. The obtained samples were characterized by a range of instruments. The water contact angle (WCA) of coated cotton was 155.6°, whi',
				link_url: 'https://doi.org/10.1016/j.envpol.2019.113277',
				link_url_check: 'NONE',
				year: 2012,
				lang: 'en',
				keywords: ['water', 'robust', 'oil', 'regents weak', 'superhydrophobic'],
				Taxon_ids: [80489],
				science_index: 'Nanoparticles;Porosity;Textiles;Ultraviolet Rays;Water;Water Purification',
			},
		],
		taxa_id: 80489,
		cname: 'Here',
		sname: 'Here',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/7f/d4/f4/542.4071919458.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
	{
		articles: [
			{
				title:
					'Sandwich-structured composite fibrous membranes with tunable porous structure for waterproof, breathable, and oil-water separation applications',
				journal_title: 'Journal of colloid and interface science',
				authors: 'Jiatai Gu, Haihong Gu, Qiong Zhang, Yonghuan Zhao, Ni Li, Jie Xiong',
				summary:
					'HYPOTHESIS: In general, microporous membranes with waterproofness, breathability, and oil-water separation performance are prepared from hydrophobic raw materials and demonstrated to exhibit an interconnected porous structure. Hence, constructing porous and gradient-structured composite membranes by integrating robust hydrophobic/lipophilic polyvinylidene fluoride (PVDF) and breathable polyurethane (PU) microporous membranes could help realize a selective separation process. EXPERIMENT: Here, novel polyviny',
				link_url: 'https://doi.org/10.1016/j.jcis.2017.12.032',
				link_url_check: 'NONE',
				year: 2018,
				lang: 'en',
				keywords: [
					'separation',
					'porous structure',
					'hydrophobic',
					'breathable',
					'breathability',
					'membranes',
					'composite',
				],
				Taxon_ids: [80489, 553599],
				science_index: '',
			},
		],
		taxa_id: 553599,
		cname: 'Electron',
		sname: 'Electron',
		domain: 'Animalia',
		class: 'Genus',
		img: 'https://content.eol.org/data/media/87/d1/e5/7.CalPhotos_0091_3183_0937_0020.jpg',
	},
];



// WEBPACK FOOTER //
// ./src/dummy.js